import type { LinkProps } from 'react-router';

import { isChangeContentUrl, isChangePageUrl, isChangeShortUrl } from '@change-corgi/core/security';

/**
 * `baseUrl` is the origin the app is serving from (`utilityContext.resolveUrl('/')`). Links to
 * Change.org pages, short links and first-party content hosts don't get `nofollow`.
 */
export function getLinkRel({
	to,
	rel,
	baseUrl,
}: Pick<LinkProps, 'to' | 'rel'> & { baseUrl: string }): string | undefined {
	if (rel) return rel;
	if (typeof to !== 'string') return undefined;
	// Links to `http://` Change.org pages are common in older content, so trust is checked as `https:`.
	const trustCheckUrl = to.replace(/^http:/i, 'https:');
	const isTrusted =
		isChangePageUrl(trustCheckUrl, { baseUrl }) ||
		isChangeShortUrl(trustCheckUrl, { baseUrl }) ||
		isChangeContentUrl(trustCheckUrl, { baseUrl });
	return isTrusted ? undefined : 'nofollow noopener noreferrer';
}
